var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngola(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16_1436)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16_1436",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16_1436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 3H1V23.4189H36V3Z",
    fill: "#BD1F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 13.2061H1V23.4121H36V13.2061Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9414 12.8574L18.0215 12.0713L19.1016 12.8574L18.6846 11.5859L19.7647 10.7998H18.4317L18.0215 9.52832L17.6045 10.7998H16.2715L17.3516 11.5859L16.9414 12.8574Z",
    fill: "#F1D631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7773 19.1191C23.6201 18.8594 23.4218 18.6748 23.1689 18.4492C22.916 18.2236 22.5605 17.9707 22.3007 17.7246L21.8017 18.3057C21.7812 18.333 21.788 18.3877 21.8154 18.3945C22.3691 18.4902 22.5468 18.6885 22.7724 18.8799C23.0732 19.1807 23.1963 19.5498 23.3877 19.6865C23.75 19.9258 24.0097 19.4951 23.7773 19.1191ZM22.4716 18.1963C22.4375 18.1963 22.4033 18.1689 22.4033 18.1279C22.4033 18.0937 22.4375 18.0596 22.4716 18.0596C22.5127 18.0596 22.54 18.0869 22.54 18.1279C22.54 18.1621 22.5058 18.1963 22.4716 18.1963ZM22.9775 18.6338C22.9365 18.6338 22.9091 18.6064 22.9091 18.5654C22.9091 18.5312 22.9365 18.4971 22.9775 18.4971C23.0185 18.4971 23.0459 18.5312 23.0459 18.5654C23.0459 18.6064 23.0117 18.6338 22.9775 18.6338ZM23.4218 19.085C23.3808 19.085 23.3535 19.0508 23.3535 19.0166C23.3535 18.9756 23.3808 18.9482 23.4218 18.9482C23.456 18.9482 23.4902 18.9756 23.4902 19.0166C23.4834 19.0508 23.456 19.085 23.4218 19.085Z",
    fill: "#F1D631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3134 16.9727C18.9101 17.1094 18.4726 17.1914 18.0146 17.1914C17.0576 17.1914 16.1894 16.8359 15.499 16.2754L14.9179 16.9863C15.164 17.1846 15.4306 17.3691 15.7109 17.5195L15.5127 17.8955C15.8203 18.0596 16.1416 18.1963 16.4765 18.292L16.5927 17.8955C16.8935 17.9912 17.208 18.0527 17.5361 18.0869L17.4951 18.4902C17.8437 18.5244 18.1855 18.5244 18.5341 18.4902L18.4931 18.0869C18.8213 18.0527 19.1357 17.9912 19.4365 17.9023L19.5527 18.292C19.7168 18.2441 19.8808 18.1826 20.0381 18.1211L19.8193 17.2871L19.3134 16.9727Z",
    fill: "#F1D631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 13.2061C22 14.4229 21.4532 15.5166 20.5918 16.2412L21.7129 17.0137C21.8565 16.8701 22 16.7197 22.1231 16.5625L21.8086 16.3027C22.0137 16.0566 22.1914 15.79 22.3418 15.5029L22.6973 15.6943C22.8614 15.3867 22.9981 15.0654 23.0938 14.7305L22.7041 14.6143C22.793 14.3135 22.8614 13.999 22.8887 13.6709L23.292 13.7119C23.3262 13.3633 23.3262 13.0146 23.292 12.6729L22.8887 12.7139C22.8545 12.3926 22.793 12.0713 22.6973 11.7705L23.0869 11.6543C22.9844 11.3193 22.8545 10.998 22.6905 10.6904L22.3282 10.8887C22.1778 10.6084 21.9932 10.3418 21.7881 10.0957L22.1162 9.8291C21.8975 9.5625 21.6514 9.31641 21.378 9.09082L21.1114 9.41895C20.8653 9.2207 20.5987 9.04297 20.3116 8.89258L20.5166 8.50977C20.209 8.3457 19.8877 8.21582 19.5528 8.11328L19.4297 8.53027C19.1358 8.44141 18.835 8.37988 18.5205 8.3457L18.4248 9.25488C20.4346 9.48047 22 11.1553 22 13.2061Z",
    fill: "#F1D631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4482 16.7812C19.3955 16.043 18.3086 15.2773 17.3994 14.416C17.3926 14.4092 17.3926 14.3955 17.3994 14.3887C17.4062 14.3818 17.4199 14.3818 17.4336 14.3887C18.3428 15.25 19.4297 16.0088 20.4824 16.7539C21.002 17.123 21.5352 17.499 22.041 17.8818L22.1982 17.6973C20.4482 16.4463 16.3125 13.5752 16.2578 12.5293C15.4375 14.1221 16.4766 15.0791 17.1465 15.4551C18.8418 16.4189 19.9697 17.0547 21.7402 18.2373L22.0068 17.9229C21.501 17.5195 20.9678 17.1436 20.4482 16.7812Z",
    fill: "#F1D631"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_1436",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_1436"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_1436",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngola);
export default __webpack_public_path__ + "static/media/Angola.157ef3e35d5dc00b4e612e951a0e4f9a.svg";
export { ForwardRef as ReactComponent };